export const DATE_COLUMN_KEYS = [
  "purchase_date",
  "date_added_ns",
  "date_added_jetsik",
  "date_added_wp",
  "date_added_html",
  "activation_date",
  "status_change_date",
  "associated_domains_date",
  "created_at",
] as const;

export const VISIBILITY_STORAGE_KEY = "domains-table-visibility";
